import React from 'react';
import { Button, Form } from 'react-bootstrap';
import { AI_CHAT_MAX_MESSAGE_LENGTH } from '../../config_and_helpers/config';
import { AI_CHAT_COMPOSER_PLACEHOLDER } from './aiChatCopy';
import './AiChatStyle.css';

/**
 * Message composer for Materiah AI chat.
 *
 * @param {Object} props
 * @param {string} props.value
 * @param {function} props.onChange
 * @param {function} props.onSend
 * @param {boolean} props.disabled
 * @param {boolean} [props.sending]
 * @returns {JSX.Element}
 */
const AiChatComposer = ({
  value,
  onChange,
  onSend,
  disabled,
  sending = false,
}) => {
  const trimmed = (value || '').trim();
  const overLimit = (value || '').length > AI_CHAT_MAX_MESSAGE_LENGTH;
  const canSend = !disabled && !sending && trimmed.length > 0 && !overLimit;

  const handleKeyDown = event => {
    if (event.key === 'Enter' && !event.shiftKey) {
      event.preventDefault();
      if (canSend) {
        onSend();
      }
    }
  };

  return (
    <div className="ai-chat-composer">
      <div className="ai-chat-composer__row">
        <Form.Control
          as="textarea"
          rows={3}
          value={value}
          onChange={e => onChange(e.target.value)}
          onKeyDown={handleKeyDown}
          disabled={disabled || sending}
          placeholder={AI_CHAT_COMPOSER_PLACEHOLDER}
          aria-label="Materiah AI message"
          maxLength={AI_CHAT_MAX_MESSAGE_LENGTH}
        />
        <Button
          variant="primary"
          onClick={onSend}
          disabled={!canSend}
          aria-busy={sending}
        >
          {sending ? '…' : 'Send'}
        </Button>
      </div>
      <div className="ai-chat-composer__hint">
        {(value || '').length}/{AI_CHAT_MAX_MESSAGE_LENGTH}
        {overLimit ? ' — message too long' : ''}
      </div>
    </div>
  );
};

export default AiChatComposer;
